module.exports = __webpack_public_path__ + "static/bg.9c1114b1.png";